import axios from 'axios';
import config from '../config/config';
import storage from '../Storage';
import Toast from '../Toast';

export const AuthService = {
  async login(creds: { email: string; password: string }) {
    try {
      const response = await axios.post(`${config.baseUrl}/login`, creds);
      storage.set('user', response.data);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async register(creds: { email: string; password: string; password_confirmation: string }) {
    try {
      const response = await axios.post(`${config.baseUrl}/register`, creds);
      // storage.set('user', response.data);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async logout() {
    try {
      const response = await axios.post(`${config.baseUrl}/logout`);
      storage.remove('user');
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
};
